export const DEDALO_DOMAIN = 'https://dedalo.oroibidea.es';
export const DEDALO_API_URL = DEDALO_DOMAIN + '/dedalo/lib/dedalo/publication/server_api/v1/json';
export const DEDALO_DB_NAME = 'dedalo4_public';
export const DEDALO_CODE = 'inm3014rtAw_testimonios';
